import type { WorldCupForecastState, WorldCupTeamId } from '@wc26-forecast/model/types';
import { clearNextMatchResults } from './clearNextMatchResults';

export function clearMatchResultsByTeamIds(
  state: WorldCupForecastState,
  teamIds: WorldCupTeamId[],
) {
  const affectedMatchIds = state.matches.ids.filter((matchId) => {
    const result = state.prediction.matchResults[matchId];
    return (
      result &&
      teamIds.some((teamId) => (
        result.winnerTeamId === teamId ||
        result.loserTeamId === teamId
      ))
    );
  });
  affectedMatchIds.forEach((matchId) => {
    delete state.prediction.matchResults[matchId];
  });
  affectedMatchIds.forEach((matchId) => {
    clearNextMatchResults(state, matchId);
  });
}
